import { render } from "./SocialIconsStyle.vue?vue&type=template&id=37764362"
import script from "./SocialIconsStyle.vue?vue&type=script&lang=ts"
export * from "./SocialIconsStyle.vue?vue&type=script&lang=ts"
script.render = render

export default script